import { connect } from 'react-redux';
import DogInfo from "../Component/DogInfo";
import {checkZipCode, getPets, pricingCalculator, addCallLog, updateServiceOrder, getCustomerDetail, getServiceOrder, updateCallLog} from '../../../../Action'

const mapStateToProps = (state) => {
  const {ZipcodeCheck, Pet, PricingCalc, ServiceOrder, CustomerList} = state;
  return {
    ZipcodeCheck,
    Pet,
    PricingCalc,
    ServiceOrder,
    CustomerList
  }
}

const actionCreators = {
  checkZipCode,
  getCustomerDetail,
  getServiceOrder,
  getPets, 
  pricingCalculator,
  addCallLog,
  updateServiceOrder,
  updateCallLog
}
export default (connect(mapStateToProps, actionCreators)(DogInfo));